var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 6.73684 4.73684 6 6 6H18C19.2632 6 20 6.73684 20 8V16C20 17.2632 19.2632 18 18 18H6C4.73684 18 4 17.2632 4 16V8ZM2 8V16C2 18.2456 3.75439 20 6 20H18C20.2456 20 22 18.2456 22 16V8C22 5.75438 20.2456 4 18 4H6C3.75439 4 2 5.75438 2 8ZM22 8.31579C22 7.36842 21.0351 6.82456 20.2281 7.29824L12.7895 11.4211C12.2982 11.7018 11.7018 11.7018 11.2105 11.4211L3.77193 7.29824C2.96491 6.82456 2 7.36842 2 8.31579V16C2 18.2456 3.75439 20 6 20H18C20.2456 20 22 18.2456 22 16V8.31579ZM20 8.31579V16C20 17.2632 19.2632 18 18 18H6C4.73684 18 4 17.2632 4 16V8.31579C4 8.50877 3.84211 8.84211 3.42105 9.38596L10.2281 13.1754C11.2456 13.7368 12.7544 13.7368 13.7719 13.1754L20.5789 9.38596C20.1579 8.84211 20 8.50877 20 8.31579Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOutlined);
export default __webpack_public_path__ + "static/media/mail_outlined.cfd71dce.svg";
export { ForwardRef as ReactComponent };